var _classCallCheck = require("/Users/katzhang/Documents/personal-projects/katalog-firebase/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/katzhang/Documents/personal-projects/katalog-firebase/node_modules/@babel/runtime/helpers/createClass.js");

var axios = require("axios"); // Helper to deal with pulling an inner object out of returned data
// and then assigning other data as "attrs"


var pullObject = function pullObject(key) {
  return function (object) {
    var newObj = object[key];
    delete object[key];
    Object.defineProperty(newObj, "attrs", {
      value: object
    });
    return newObj;
  };
}; // Helper to accept an array or multiple arguments
// and convert to array


var arrayOrList = function arrayOrList(list) {
  if (typeof list[0] === "object" || typeof list[0] === "array") {
    return list[0];
  }

  return list;
};

var Arena = /*#__PURE__*/function () {
  "use strict";

  function Arena(opts) {
    var _this = this;

    _classCallCheck(this, Arena);

    opts = opts || {};
    var headers = {
      "Content-Type": "application/json"
    };

    if (opts.accessToken) {
      headers["Authorization"] = "Bearer ".concat(opts.accessToken);
    }

    if (opts.authToken) {
      headers["X-AUTH-TOKEN"] = "".concat(opts.authToken);
    }

    this.axios = axios.create({
      baseURL: opts.baseURL || "https://api.are.na/v2/",
      headers: headers
    });

    this.requestHandler = opts.requestHandler || function (method, url, data) {
      return method === "get" ? _this.axios.request({
        method: method,
        url: url,
        params: data
      }).then(function (_ref) {
        var data = _ref.data;
        return data;
      }) : _this.axios.request({
        method: method,
        url: url,
        data: data
      }).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      });
    };
  }

  _createClass(Arena, [{
    key: "_req",
    value: function _req(method, url) {
      for (var _len = arguments.length, data = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        data[_key - 2] = arguments[_key];
      }

      return this.requestHandler(method.toLowerCase(), url, Object.assign.apply(Object, [{}].concat(data)));
    }
  }, {
    key: "group",
    value: function group(slug) {
      var _this2 = this;

      slug = slug || "";
      return {
        get: function get(opts) {
          return _this2._req("GET", "groups/" + slug, opts);
        },
        channels: function channels(opts) {
          return _this2._req("GET", "groups/" + slug + "/channels", opts).then(pullObject("channels"));
        }
      };
    }
  }, {
    key: "channel",
    value: function channel(slug, data) {
      var _this3 = this;

      slug = slug || "";
      return {
        get: function get(opts) {
          return _this3._req("GET", "channels/" + slug, data, opts);
        },
        thumb: function thumb(opts) {
          return _this3._req("GET", "channels/" + slug + "/thumb", data, opts);
        },
        connections: function connections(opts) {
          return _this3._req("GET", "channels/" + slug + "/connections", data, opts).then(pullObject("channels"));
        },
        channels: function channels(opts) {
          return _this3._req("GET", "channels/" + slug + "/channels", data, opts).then(pullObject("channels"));
        },
        contents: function contents(opts) {
          return _this3._req("GET", "channels/" + slug + "/contents", data, opts).then(pullObject("contents"));
        },
        collaborators: function collaborators(opts) {
          return _this3._req("GET", "channels/" + slug + "/collaborators", data, opts).then(pullObject("users"));
        },
        create: function create(title, status) {
          return _this3._req("POST", "channels", {
            // Allow it to be called as .channel(title).create(status) or
            // .channel().create(title, status)
            title: slug || title,
            status: slug ? title : status
          });
        },
        delete: function _delete(deleteSlug) {
          return _this3._req("DELETE", "channels/" + (slug || deleteSlug));
        },
        update: function update(opts) {
          return _this3._req("PUT", "channels/" + slug, opts);
        },
        addCollaborators: function addCollaborators() {
          for (var _len2 = arguments.length, ids = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            ids[_key2] = arguments[_key2];
          }

          return _this3._req("POST", "channels/" + slug + "/collaborators", {
            "ids[]": arrayOrList(ids)
          }).then(pullObject("users"));
        },
        deleteCollaborators: function deleteCollaborators() {
          for (var _len3 = arguments.length, ids = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            ids[_key3] = arguments[_key3];
          }

          return _this3._req("DELETE", "channels/" + slug + "/collaborators", {
            "ids[]": arrayOrList(ids)
          }).then(pullObject("users"));
        },
        createBlock: function createBlock(opts) {
          if (opts.content.match(/^https?:\/\//)) {
            opts.source = opts.content;
          }

          return _this3._req("POST", "channels/" + slug + "/blocks", opts);
        },
        deleteBlock: function deleteBlock(id) {
          return _this3._req("DELETE", "channels/" + slug + "/blocks/" + id);
        }
      };
    }
  }, {
    key: "block",
    value: function block(id, data) {
      var _this4 = this;

      return {
        get: function get(opts) {
          return _this4._req("GET", "blocks/" + id, data, opts);
        },
        channels: function channels(opts) {
          return _this4._req("GET", "blocks/" + id + "/channels", data, opts).then(pullObject("channels"));
        },
        create: function create(channel, opts) {
          return _this4.channel(channel).createBlock(opts);
        },
        update: function update(opts) {
          return _this4._req("PUT", "blocks/" + id, data, opts);
        }
      };
    }
  }, {
    key: "user",
    value: function user(id, data) {
      var _this5 = this;

      return {
        get: function get(opts) {
          return _this5._req("GET", "users/" + id, data, opts);
        },
        channels: function channels(opts) {
          return _this5._req("GET", "users/" + id + "/channels", data, opts).then(pullObject("channels"));
        },
        following: function following(opts) {
          return _this5._req("GET", "users/" + id + "/following", data, opts).then(pullObject("following"));
        },
        followers: function followers(opts) {
          return _this5._req("GET", "users/" + id + "/followers", data, opts).then(pullObject("users"));
        }
      };
    }
  }, {
    key: "search",
    value: function search(q, data) {
      var _this6 = this;

      return {
        all: function all(opts) {
          return _this6._req("GET", "search", {
            q: q
          }, data, opts);
        },
        users: function users(opts) {
          return _this6._req("GET", "search/users", {
            q: q
          }, data, opts).then(pullObject("users"));
        },
        channels: function channels(opts) {
          return _this6._req("GET", "search/channels", {
            q: q
          }, data, opts).then(pullObject("channels"));
        },
        blocks: function blocks(opts) {
          return _this6._req("GET", "search/blocks", {
            q: q
          }, data, opts).then(pullObject("blocks"));
        }
      };
    }
  }]);

  return Arena;
}();

module.exports = Arena;